import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ProjectState } from './Project.types';

export const initialState: ProjectState = {
  isModalOpen: false,
};
export const ProjectReducer = createSlice({
  name: 'project',
  initialState,
  reducers: {
    setModalStatus: (state, action: PayloadAction<{ value: boolean }>) => {
      state.isModalOpen = action.payload.value;
    },
  },
});
export const { setModalStatus } = ProjectReducer.actions;

export default ProjectReducer.reducer;
